export default {
      id: "paket-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#paket",
      toString: function () {
        return this.url;
      }
    }